<template>
  <v-toolbar app :color="toolbar.back">
    <v-toolbar-side-icon v-if="menulateral.length>0" @click.stop="$emit('clique-menu-lateral')"></v-toolbar-side-icon>
    <v-toolbar-title class="headline">
      <span :class="toolbar.class">{{toolbar.title}}</span>
    </v-toolbar-title><!--
    <v-spacer></v-spacer>
    <v-toolbar-items class="mx-0">
      <v-btn v-if="qtdItensPedido>0" color="" fab icon flat value="pedidos" @click.stop="$emit('abrir-dialog-pedido')">
        <v-badge color="cyan" right>
          <template v-slot:badge>
            <span>{{qtdItensPedido}}</span>
          </template>
          <v-icon>shopping_cart</v-icon>
        </v-badge>
      </v-btn>
      <v-btn disabled flat icon v-else>
        <v-icon>shopping_cart</v-icon>
      </v-btn>
    </v-toolbar-items> -->
  </v-toolbar>
</template>

<script>
export default {
  props: ["qtdItensPedido","toolbar","menulateral"],
  data() {
    return {
      
    }
  },
  methods: {
    
  }
};
</script>

<style>
</style>